var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7022 60.6346C73.122 54.6162 75.0817 47.5333 75.0817 40C75.0817 17.9734 58.2517 0 37.5408 0C16.83 0 0 17.9324 0 40C0 62.0676 16.83 80 37.5408 80C41.7675 80 45.8021 79.2631 49.6062 77.871C50.8357 77.4207 52.0653 76.9294 53.2181 76.3152C53.487 76.1924 53.756 76.0696 54.025 75.9058C54.2939 75.783 54.5245 75.6192 54.7935 75.4964C55.3698 75.2098 55.9078 74.8823 56.4457 74.5138C56.6379 74.391 56.8684 74.2682 57.0605 74.1044C57.5985 73.7769 58.1364 73.4084 58.6359 72.999C58.7512 72.9171 58.8281 72.8761 58.9433 72.7943L50.8742 63.2549L34.5437 43.9713L28.9337 37.3388L18.9049 41.5558L40.4995 67.0624C39.5389 67.1853 38.5783 67.2262 37.5793 67.2262C23.4774 67.2262 11.9885 54.9846 11.9885 39.9591C11.9885 24.9335 23.4774 12.6919 37.5793 12.6919C51.6811 12.6919 63.17 24.9335 63.17 39.9591C63.17 43.6848 62.44 47.2467 61.172 50.522L36.6186 21.5353L26.5898 25.7523L66.3977 72.8352H80L69.7022 60.6346Z",
    fill: "url(#paint0_linear_258_541)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_541",
    x1: -22.3809,
    y1: -21.6667,
    x2: 123.441,
    y2: 105.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0607637,
    stopColor: "#594EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618055,
    stopColor: "#AB54C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753472,
    stopColor: "#C591D3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoader);
export default __webpack_public_path__ + "static/media/logo-loader.72625f03066b18f5f03ed72e3f3d6546.svg";
export { ForwardRef as ReactComponent };